import React, { useEffect, useState } from 'react';
import TableHeader from '../Shared/TableHeader';
import { LeadFormActions } from '../../Services/_actions';
import CommonTable from '../Shared/Tables';
import ReactPagination from '../Shared/Pagination';
import { renderToolTip } from '../../utils/helper';
import SearchBox from '../Shared/SearchBox';
import { Button, Col, Row } from 'react-bootstrap';
import FilterOffcanvas from '../Shared/FilterOffcanvas';
import SelectDropdown from '../Shared/SelectDropdown';
import { Link } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { agentSelectedDispositionAtom } from '../../Services/_states/CallerDashboard';
import DateRangeFilter from '../Shared/DateRangeFilter/DateRangeFilter.tsx';
import FilterListIcon from '@mui/icons-material/FilterList';
import useDebounce from '../Shared/Delay/index.tsx';

const AgentSummary = () => {
  const leadFormActions = LeadFormActions();
  const [selectedDispositionArr, setSelectedDispositionArr] = useRecoilState(
    agentSelectedDispositionAtom
  );
  const [agentSummaryData, setAgentSummaryData] = useState({});
  const [filterObj, setFilterObj] = useState({
    search: '',
    page: 0,
    limit: 10,
    startDate: null,
    endDate: null,
    disposition: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [isColumnsReset, setIsColumnsReset] = useState(false);
  const [searchInput, setSearchInput] = useState(filterObj?.search);
  const debouncedSearch = useDebounce(searchInput, 500);

  const initialColumns = [
    {
      dataField: 'index',
      text: 'S.No.',
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerAlign: 'center',
      align: 'center',
      headerStyle: { width: '50px' },
    },
    {
      dataField: 'agent_name',
      text: 'Name',
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'agent_number',
      text: 'Number',
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'total_calls',
      text: 'Total calls',
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row) => {
        return (
          <Link
            to={`date-wise-summary/${row?.agent_name || 'Agent'}/${row?.agent_number || ''}/total_calls`}
          >
            {row?.total_calls}
          </Link>
        );
      },
    },
  ];
  const [columns, setColumns] = useState(initialColumns);

  const addColumns = () => {
    if (selectedDispositionArr?.length) {
      const col = [
        ...initialColumns,
        ...selectedDispositionArr?.map((item) => ({
          // dataField: item.value.toLowerCase().replace(/\s+/g, '_'),
          dataField: item.value,
          text: item.label,
          headerAlign: 'center',
          align: 'center',
          formatter: (cell, row) => {
            if (row?.dispositions?.[item.value] && row?.dispositions?.[item.value] > 0)
              return (
                <Link
                  to={`date-wise-summary/${row?.agent_name || 'Agent'}/${row?.agent_number || ''}/${item.value || 'total_calls'}`}
                >
                  {row?.dispositions?.[item.value] || 0}
                </Link>
              );
            else return <span>0</span>;
          },
        })),
      ];
      setColumns(col);
    } else {
      setColumns([...initialColumns]);
    }
  };

  const clearFilters = () => {
    let obj = {
      search: '',
      page: 0,
      limit: 10,
      start_date: null,
      end_date: null,
      disposition: '',
    };
    setSelectedDispositionArr([]);
    setFilterObj(obj);
    getAgentSummaryData(obj);
  };

  const getAgentSummaryData = async (obj) => {
    setIsLoading(true);
    setIsColumnsReset(true);
    if (selectedDispositionArr) {
      const str = selectedDispositionArr?.map((item) => item?.value).join(',');
      // setFilterObj({ ...filterObj, disposition: str || null });
      obj = { ...obj, disposition: str };
    }

    let res = await leadFormActions.getAgentSummaryData(obj);
    if (res?.status === 200) setAgentSummaryData(res?.data || {});
    setIsLoading(false);
  };

  const onPageChange = (e) => {
    getAgentSummaryData({ ...filterObj, page: e?.selected });
    setFilterObj({ ...filterObj, page: e?.selected });
  };

  const onSearch = (e) => {
    setFilterObj({ ...filterObj, search: e });
    if (e.length > 2 || !e) getAgentSummaryData({ ...filterObj, search: e, page: 0 });
  };

  const onSelectDisposition = (e) => {
    setSelectedDispositionArr(e);
    // if (e) {
    //     const str = e?.map(item => item?.value).join(",");
    //     setFilterObj({ ...filterObj, disposition: str || null });
    // }
  };

  const handleTableChange = (type, { sortField, sortOrder, data }) => {
    // if (type === 'sort') {
    //     if (sortField !== filters.sort_by || sortOrder !== filters.order) {
    //         setFilterObj({ ...filters, sort_by: sortField, order: sortOrder });
    //         setAgentSummaryData({ ...filters, sort_by: sortField, order: sortOrder });
    //     }
    // }
  };

//   useEffect(() => {
//     getAgentSummaryData(filterObj);
//   }, []);

  useEffect(() => {
    if (isColumnsReset) {
      addColumns();
      setIsColumnsReset(false);
    }
  }, [isColumnsReset]);

  useEffect(() => {
    if (debouncedSearch.length > 2 || debouncedSearch === '') {
      getAgentSummaryData({ ...filterObj, search: debouncedSearch, page: 0 });
      setFilterObj({ ...filterObj, search: debouncedSearch, page: 0 });
    }
  }, [debouncedSearch]);

  return (
    <>
      <TableHeader headerValue={'Agent Summary'} />
      <div className="d-flex">
        <div>
          {renderToolTip(
            'Filters',
            <FilterListIcon
              style={{ fontSize: '20px', margin: '5px', cursor: 'pointer' }}
              onClick={() => {
                setShowFilter(true);
              }}
            />
          )}
        </div>
        <div className="pb-2">
          <SearchBox
            onSearch={(val) => setSearchInput(val)}
            placeholder="Search"
            value={searchInput}
          />
        </div>{' '}
      </div>

      <CommonTable
        id={'agent_number'}
        columnsData={columns}
        rowData={agentSummaryData?.list || []}
        // defaultSorted={[{ dataField: filterObj?.sort_by, order: filterObj?.order }]}
        handleTableChange={handleTableChange}
        remote={{ sort: true }}
        isLoading={isLoading}
      />
      <ReactPagination
        pageNo={filterObj?.page}
        pageSize={filterObj?.limit}
        totalItems={agentSummaryData?.count}
        onPageChange={onPageChange}
      />

      <FilterOffcanvas
        show={showFilter}
        onHide={() => setShowFilter(false)}
        bodyData={
          <>
            <div className="mb-3">
              <SelectDropdown
                optionsData={leadFormActions.despositionStatusArr}
                selectedValue={selectedDispositionArr}
                placeholder="Select Disposition"
                handleSelect={(e) => {
                  onSelectDisposition(e);
                }}
                isClearable={true}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
            <div className="mb-3">
              <DateRangeFilter
                isClearable={true}
                handleDateChange={(dates) => {
                  setFilterObj({ ...filterObj, startDate: dates[0], endDate: dates[1] });
                }}
                startDate={filterObj?.startDate}
                endDate={filterObj?.endDate}
                onApply={(dates) => {
                  // Handle the date apply action here.
                  setFilterObj({
                    ...filterObj,
                    startDate: dates.startDate,
                    endDate: dates.endDate,
                  });
                }}
              />
            </div>
            <Row>
              <Col>
                <Button
                  variant="primary"
                  onClick={() => {
                    getAgentSummaryData(filterObj), setShowFilter(false);
                  }}
                >
                  Submit
                </Button>
              </Col>
              <Col>
                <Button
                  variant="secondary"
                  onClick={() => {
                    clearFilters(), setShowFilter(false);
                  }}
                >
                  Clear
                </Button>
              </Col>
            </Row>
          </>
        }
      />
    </>
  );
};

export default AgentSummary;
